<!-- Loader starts-->
<div class="loader-wrapper" [class.loderhide]="!show">
  <div class="bg-white loader">
    <div class="line"></div>
    <div class="line"></div>
    <div class="line"></div>
    <div class="line"></div>
  </div>
</div>
<!-- Loader ends-->